import { Link } from 'react-router-dom';

interface Service {
  id: string;
  title: string;
  price: number;
  category: string;
  image: string;
}

interface RelatedServicesProps {
  services: Service[];
  currentServiceId: string;
}

export default function RelatedServices({ services, currentServiceId }: RelatedServicesProps) {
  const relatedServices = services.filter(service => service.id !== currentServiceId).slice(0, 3);

  return (
    <div className="py-16">
      <h2 className="text-3xl font-bold text-gray-900 mb-8">Related Services</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {relatedServices.map((service) => (
          <div key={service.id} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <Link to={`/service/${service.id}`}>
              <div className="w-full h-64">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
              </div>
            </Link>
            
            <div className="p-6">
              <p className="text-sm text-gray-600 mb-2">{service.category}</p>
              <Link to={`/service/${service.id}`}>
                <h3 className="text-xl font-bold text-gray-900 mb-3 hover:text-cyan-600 transition-colors">
                  {service.title}
                </h3>
              </Link>
              <p className="text-2xl font-bold text-gray-900 mb-4">${service.price.toFixed(2)}</p>
              
              <button className="w-full bg-gray-900 text-white px-6 py-2 rounded-md hover:bg-gray-800 transition-colors font-medium text-sm whitespace-nowrap">
                Add to cart
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}